import { useEffect, useState } from 'react';
import { request, gql } from "graphql-request"
import { ethers } from 'ethers'

const WARDEN_FARM_SUBGRAPH_URL = process.env.REACT_APP_WARDEN_FARM_SUBGRAPH_URL
const PANCAKE_FARM_SUBGRAPH_URL = process.env.REACT_APP_PANCAKE_FARM_SUBGRAPH_URL

export interface ApiStatResponse {
	[address: string]: {
		reserveUSD: number,
	}
}

export const useFarmTVL = (farms: string[]) => {
	const [data, setData] = useState<ApiStatResponse | null>(null);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const [wardenFarm] = await Promise.all([
					request(
						WARDEN_FARM_SUBGRAPH_URL,
						gql`
							query pairs($addresses: [String]!) {
								pairs(where: { id_in: $addresses }) {
									id
									reserveUSD
								}
							}
						`,
						{ addresses: farms }
					)
				]);


				// request(
				// 	PANCAKE_FARM_SUBGRAPH_URL,
				// 	gql`
				// 		{
				// 			pairs(
				// 				where: {
				// 					id_in: [
				// 						"0xf70a40749006c7952186666c92f32b8f5c2129f9"
				// 						"0x7d6195b212dee1ba7de8404cfd319446cf17d71b"
				// 					]
				// 				}
				// 			) {
				// 				id
				// 				reserveUSD
				// 			}
				// 		}
				// 	`,
				// )

				const groupOfFarm = [...wardenFarm.pairs]
				const farmObj = {}
				groupOfFarm.forEach(farm => {
					farmObj[ethers.utils.getAddress(farm.id)] = {
						reserveUSD: Number(farm.reserveUSD),
					};
				})
				setData(farmObj)
			} catch (error) {
				// @ts-ignore
				console.error('Unable to fetch data:', error);
			}
		};

		fetchData();
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return data;
}